import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from "../../../project-constants";
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {Subscription} from "rxjs";
import {ActivatedRoute, Router} from "@angular/router";
import {ServiceVariantModel} from "../../../../models/ServiceVariantModel";
import {ServiceVariantService} from "../../../general-services/service-service-variant-anagraf/service-variant.service";
import * as toastr from 'toastr';

@Component({
  selector: 'app-new-service-variant-anagraf',
  templateUrl: './new-service-variant-anagraf.component.html',
  styleUrls: ['./new-service-variant-anagraf.component.scss']
})
export class NewServiceVariantAnagrafComponent extends ProjectConstants implements OnInit, OnDestroy {
  serviceVariant: ServiceVariantModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;
  saveSubscribe: Subscription;

  constructor(private route: ActivatedRoute, private router: Router,
              private serviceVariantService: ServiceVariantService) {
    super();

    this.serviceVariant = new ServiceVariantModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [this.serviceVariant.cod, [Validators.required]],
      description: [this.serviceVariant.description, [Validators.required]]
    });
  }

  ngOnInit() {

  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SERVICE_VARIANT_ANAGRF]);
  }

  save(event: any, form: NgForm, clickSalva ?: boolean) {
    if (event.key === 'Enter' || clickSalva) {
      event.preventDefault();
      this.serviceVariant.cod = this.formValidator.value.cod;
      this.serviceVariant.description = this.formValidator.value.description;
      this.saveSubscribe = this.serviceVariantService.save(this.serviceVariantService.baseUrl, this.serviceVariant).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Service Variant Cod already exists', 'Warning');
          } else {
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.SERVICE_VARIANT_ANAGRF]);
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }
}
